import api from '../token';

export const ListIsencao = async () => {
  try {
    const response = await api.post('/getMotivoIsencao');
    return response.data;
  } catch (error) {
   
    return [];
  }
};

